import { useTranslation } from "next-i18next";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import Button from "~/components/Button";
import { Container } from "~/components/Container";
import Text from "~/components/Text";
import Colors from "~/constants/colors";
import Trans from "~/types/translationKeys";
import styles from "./Hero.module.scss";

const Hero: FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.hero} id="hero">
      <Container className={styles.container}>
        <div className={styles.left}>
          <div className="max-w-[610px]">
            <Text type="title-2" color={Colors.GREY_50} className={styles.tag}>
              {t(Trans.cx_genie_ai_studio)}
            </Text>
            <p className={styles.title}>
              {t(
                Trans.creating_customized_ai_solutions_for_your_business_growth
              )}
            </p>
            <Link href="#form">
              <Button>{t(Trans.book_a_free_consultation_session)}</Button>
            </Link>
          </div>

          <Image
            src={"/images/hero_ai_studio.png"}
            width={505}
            height={456}
            alt="AI Studio"
            className="block mx-auto md:hidden"
          />

          <Text
            type="body-1"
            color={Colors.GREY_200}
            className={styles.content}
          >
            {t(
              Trans.cx_genie_ai_studio_is_where_innovation_meets_customization_to_elevate_your_business_operations
            )}
          </Text>
        </div>
        <div className={styles.right}>
          <Image
            src={"/images/hero_ai_studio.png"}
            width={505}
            height={456}
            alt="AI Studio"
          />
        </div>
      </Container>
    </section>
  );
};

export default Hero;
